/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Follow_None_YetInputs */

const en_follow_none_yet = /** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No ${i?.type} yet`)
};

const es_follow_none_yet = /** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aún no hay ${i?.type}`)
};

const fr_follow_none_yet = /** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucun ${i?.type} pour le moment`)
};

const de_follow_none_yet = /** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch keine ${i?.type}`)
};

const id_follow_none_yet = /** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Belum ada ${i?.type}`)
};

/** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */
const ja_follow_none_yet = en_follow_none_yet;

/** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */
const zh_follow_none_yet = en_follow_none_yet;

/** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */
const ar_follow_none_yet = en_follow_none_yet;

/** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */
const it_follow_none_yet = en_follow_none_yet;

/** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */
const ru_follow_none_yet = en_follow_none_yet;

/** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */
const pt_follow_none_yet = en_follow_none_yet;

/** @type {(inputs: Follow_None_YetInputs) => LocalizedString} */
const ko_follow_none_yet = en_follow_none_yet;

/**
* | output |
* | --- |
* | "No {type} yet" |
*
* @param {Follow_None_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_none_yet = /** @type {((inputs: Follow_None_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_None_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_none_yet(inputs)
	if (locale === "es") return es_follow_none_yet(inputs)
	if (locale === "fr") return fr_follow_none_yet(inputs)
	if (locale === "de") return de_follow_none_yet(inputs)
	if (locale === "ja") return ja_follow_none_yet(inputs)
	if (locale === "zh") return zh_follow_none_yet(inputs)
	if (locale === "ar") return ar_follow_none_yet(inputs)
	if (locale === "id") return id_follow_none_yet(inputs)
	if (locale === "it") return it_follow_none_yet(inputs)
	if (locale === "ru") return ru_follow_none_yet(inputs)
	if (locale === "pt") return pt_follow_none_yet(inputs)
	return ko_follow_none_yet(inputs)
});